<template>
  <div class="save-template-modal">
    <s-modal
      v-model="showModal"
      size="md"
      cancel-confirm-message-code="MC006"
      :title="$t('reports.data-history.summary.save-template')"
      :ok-title="$t('actions.save')"
      :ok-disabled="!templateName"
      :is-loading="isLoading"
      :confirm-type="confirmationTypes.YES_NO"
      @ok="confirm"
      @cancel="cancel"
    >
      <b-container fluid>
        <span>{{ $t('reports.data-history.summary.save-template-info') }}</span>
        <div class="mt-3">
          <label>{{ $t('reports.template-name') }}</label>
          <b-form-input
            v-model="templateName"
            maxlength="80"
          />
        </div>
      </b-container>
    </s-modal>
  </div>
</template>

<script>
import confirmationTypes from '@/constants/confirmationTypes';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'SaveTemplateModal',
  props: {
    value: Boolean,
    name: String,
    isLoading: Boolean,
  },
  data: () => ({
    confirmationTypes,
  }),
  validations() {
    return {
      templateName: {
        required,
        minLength: minLength(2),
      },
    };
  },
  computed: {
    templateName: {
      get() {
        return this.name || '';
      },
      set(value) {
        this.$emit('update:name', value);
      },
    },
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    cancel() {
      this.showModal = false;
    },
    confirm() {
      if (!this.$v.templateName.minLength || !this.$v.templateName) {
        this.$pushAlert({
          code: 'MG001',
          messageParams: {
            0: '2',
            1: '80',
          },
        });
        return;
      }
      this.$emit('save');
    },
  },
};
</script>
